<template>
  <TableGradient
      icon-name="id-card"
      :title="$t('credential.listagem.titulo_pagina')"
      :text-empty="$t('credential.listagem.table.empty')"
      route-new="vns.credential.create"
      :text-new="$t('credential.listagem.novo')"
      :fields="fields"
      :fields-filter="filter"
      :items="credentials"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('credential/listAll', evt)"
      table-data>
    <template v-slot:cell(id)="linha">
      <router-link :id="`link-edit-${linha.index}`" :to="{ name: 'vns.credential.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('credential.listagem.table.editar') }}
      </router-link>
    </template>
    <template v-slot:cell(stage)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.stage, 'badge badge-danger': !linha.item.stage}">
          <i :class="linha.item.stage ? 'fas fa-check' : 'fas fa-ban'"/>
      </span>
    </template>
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.status, 'badge badge-danger': !linha.item.status}">
          <i :class="linha.item.status ? 'fas fa-check' : 'fas fa-ban'"/>
      </span>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      credentials: 'credential/all',
      paginator: 'credential/pagination',
      store_isLoading: 'credential/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('credential.listagem.table.nome'), keyFullName: 'vns_credentials.name', sortable: true},
        {key: 'company_name', label: this.$t('credential.listagem.table.empresa')},
        {key: 'username', label: this.$t('credential.listagem.table.usuario'), sortable: true},
        {key: 'stage', label: this.$t('credential.listagem.table.homologacao'), sortable: true},
        {key: 'status', label: 'Status', keyFullName: 'vns_credentials.status', sortable: true},
        {key: 'id', label: this.$t('credential.listagem.table.editar')}
      ],
      filter: [
        {key: 'name', label: this.$t('credential.listagem.table.nome')},
        {key: 'company_name', label: this.$t('credential.listagem.table.empresa')},
      ]
    }
  },
  methods: {
    ...mapActions([
      'credential/listAll'
    ])
  },
  mounted() {
    this['credential/listAll'](this.paginator)
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
